<template>
  <div id="brands" class="brands py-5 sm:py-10 relative">
    <p class="heading mb-5 sm:mb-10 font-sans text-3xl text-center">Brands</p>

    <ul class="flex flex-col sm:flex-row sm:flex-wrap md:flex-no-wrap justify-center content-center items-center">
      <li v-if="getBrands.length < 1" class="col-span-12"><Loading /></li>

      <li
        else
        v-for="(item, index) in getBrands"
        :key="index"
        :class="[
            'block sm:w-1/2 py-4 md:py-0 md:px-4',
            'transform scale-100'
          ]"
      >
        <!-- <a :href="item.slug" :class="[ 'block transition duration-300 hover:scale-90 relative overflow-hidden' ]"> -->
          <picture class="img flex flex-row flex-no-wrap justify-center">
            <img :src="item.image.src.indexOf('http') !== -1 ? item.image.src : require(`@/img/${item.image.src}`)" :alt="item.name" width="200" height="auto" />
          </picture>
        <!-- </a> -->
      </li>
    </ul>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'Brands',

  components: {
    Loading,
  },

  data() {
    return {
      id: null,
    }
  },

  computed: {
    ...mapState({
      axiosWc: "axiosWc",
    }),
    ...mapGetters([ 'getBrands', 'getUrlApi' ]),
  },

  created: function () {
  },

  mounted: async function() {
    if(this.getBrands.length > 0) {
      return;
    }

    /**
     * Get the Brand category from WooCommerce product_cat
     */
    const categoryBrand = await this.axiosWc.get(`${this.getUrlApi}/wc/v3/products/categories/?slug=brands`);

    /**
     * Get the brands whose parent is the Brand product_cat
     */
    const allBrands = await this.axiosWc.get(`${this.getUrlApi}/wc/v3/products/categories/?parent=${categoryBrand.data[0].id}`);
    this.setBrands(allBrands.data);

    // Created a new timeline
    // var brandTl = gsap.timeline({ defaults: { duration: 1 } });
    // brandTl
    // 	.staggerFromTo('.img', 1, { translateY: 50, scale: 0.75, opacity: 0 }, { duration: 1.5, translateY: 0, scale: 1, opacity: 1 }, 0.25 )
  },

  methods: {
    ...mapActions({
      setBrands: "setBrands",
    }),
  },
}
</script>

<style lang="scss" scoped>
</style>
